import { kpis, kpiTrend } from "@/data/roadmap";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { SectionLabel } from "./ExecSummary";
import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid, Legend } from "recharts";

export default function Kpis() {
  return (
    <section
      id="kpis"
      data-testid={ROADMAP.kpiSection}
      className="py-20 lg:py-28 border-b border-[#DEE2E6] bg-[#F8F9FA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionLabel n="06" label="KPIs & Dashboards" />
        <div className="grid lg:grid-cols-12 gap-6 mt-3 items-end">
          <h2 className="lg:col-span-7 font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold">
            What gets measured, gets managed.
          </h2>
          <p className="lg:col-span-5 text-[#495057] leading-relaxed">
            Every module ships with executive dashboards and target KPIs. Gr8Agentic AI keeps watch and
            surfaces trends, anomalies, and forecasts.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-0 border border-[#0A0A0A] bg-white">
          {/* Chart */}
          <div className="lg:col-span-7 border-b lg:border-b-0 lg:border-r border-[#0A0A0A] p-6 lg:p-8">
            <div className="flex items-center justify-between mb-6">
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#FF4F00] font-mono">
                  6-month rollout outlook
                </div>
                <div className="font-heading font-bold text-xl mt-1">
                  Trend — DSO · Stock Accuracy · User Adoption
                </div>
              </div>
            </div>
            <div style={{ width: "100%", height: 320 }}>
              <ResponsiveContainer>
                <LineChart data={kpiTrend} margin={{ top: 10, right: 16, left: -10, bottom: 0 }}>
                  <CartesianGrid stroke="#DEE2E6" strokeDasharray="0" vertical={false} />
                  <XAxis dataKey="month" stroke="#495057" tick={{ fontSize: 12 }} />
                  <YAxis stroke="#495057" tick={{ fontSize: 12 }} />
                  <Tooltip
                    contentStyle={{
                      background: "#0A0A0A",
                      border: "1px solid #0A0A0A",
                      borderRadius: 0,
                      color: "#fff",
                      fontSize: 12,
                    }}
                    labelStyle={{ color: "#FF4F00", fontWeight: 600 }}
                  />
                  <Legend wrapperStyle={{ fontSize: 12 }} />
                  <Line type="monotone" dataKey="dso" stroke="#D90429" strokeWidth={2} dot={{ r: 3 }} name="DSO (days)" />
                  <Line type="monotone" dataKey="accuracy" stroke="#0B7A75" strokeWidth={2} dot={{ r: 3 }} name="Stock accuracy %" />
                  <Line type="monotone" dataKey="adoption" stroke="#0033A0" strokeWidth={2} dot={{ r: 3 }} name="User adoption %" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* KPI list */}
          <div className="lg:col-span-5">
            <div className="px-6 py-4 border-b border-[#0A0A0A] bg-[#0A0A0A] text-white text-xs uppercase tracking-[0.2em]">
              Target KPIs · All departments
            </div>
            <div className="max-h-[400px] overflow-y-auto">
              {kpis.map((k, i) => (
                <div
                  key={k.kpi}
                  className={`grid grid-cols-[auto_1fr_auto] items-center gap-4 px-6 py-3.5 ${
                    i !== kpis.length - 1 ? "border-b border-[#DEE2E6]" : ""
                  } hover:bg-[#F8F9FA] transition-colors`}
                  data-testid={`kpi-row-${i}`}
                >
                  <span className="text-[10px] font-mono uppercase tracking-[0.15em] text-[#495057] w-16">
                    {k.dept}
                  </span>
                  <span className="text-sm text-[#0A0A0A]">{k.kpi}</span>
                  <span className="text-sm font-semibold text-[#0033A0] tabular-nums">
                    {k.target}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
